import { render, staticRenderFns } from "./Patent.vue?vue&type=template&id=0a22ab2f&scoped=true"
var script = {}
import style0 from "./Patent.vue?vue&type=style&index=0&id=0a22ab2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22ab2f",
  null
  
)

export default component.exports